import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardComponent from "../../components/card";
import InputComponent from "../../components/input";
import { ChangeEvent, FormEvent, useState } from "react";
import LoadingComponent from "../../components/loading";
import { CreateTypeService } from "../../services/types";
import { ToastErro, ToastSucesso } from "../../components/toast";

const CreateTypePage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);

    const [descripttion, setDescription] = useState<string>('');

    // funcao para cadastrar tipo
    const createType = async (e: FormEvent) => {

        e.preventDefault();

        setLoading(true);

        await CreateTypeService(descripttion).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/types');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        })

        setLoading(false);

    }
    // funcao para cadastrar tipo

    return (
        <>
            <HeaderComponent
                title="Cadastrar Tipo"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/types')}
            />
            <ContainerComponent>
                {
                    loading

                        ?

                        <LoadingComponent />

                        :

                        <>
                            <div className="row">
                                <CardComponent
                                    col={12}
                                >
                                    <form onSubmit={createType}>
                                        <div className="card-title mb-4">
                                            Informações do Tipo
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Descrição"
                                                col={12}
                                                defaultValue={descripttion}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end mt-4">
                                            <button className="btn btn-primary" type="submit">Cadastrar</button>
                                        </div>
                                    </form>
                                </CardComponent>
                            </div>
                        </>
                }
            </ContainerComponent>
        </>
    );

}

export default CreateTypePage;